import React, { Component } from 'react';
import {Grid, Message} from 'semantic-ui-react';
import "./App.css";
import ColorPanel from './ColorPanel/ColorPanel';
import SidePanel from './SidePanel/SidePanel';
import Messages from './Messages/Messages';
import MetaPanel from './MetaPanel/MetaPanel';
import { connect } from 'react-redux';
import SkyBg from './Sky/SkyBg';

const App = ({currentUser, currentChannel, isPrivateChannel, userPosts, primaryColor, secondaryColor, emotionProbability}) => (
  
  <Grid columns="equal" className="app" style={{background: secondaryColor}}>

    

    <ColorPanel 
      key={currentUser && currentUser.name}
      currentUser={currentUser}
    />
    <SidePanel 
      key={currentUser && currentUser.uid}
      currentUser={currentUser}
      primaryColor={primaryColor}
      emotionProbability={emotionProbability}
     />
    <Grid.Column style={{ marginLeft: 320 }}>
      <Messages
        key={currentChannel && currentChannel.id}
        currentChannel={currentChannel}
        currentUser={currentUser}
        isPrivateChannel={isPrivateChannel}
      />
    </Grid.Column>

    <Grid.Column width={4}>
      <MetaPanel 
        key={currentChannel && currentChannel.name}
        currentChannel={currentChannel}
        isPrivateChannel={isPrivateChannel} 
        userPosts={userPosts}
      />
    </Grid.Column>
    
  </Grid>
)
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentChannel: state.channel.currentChannel,
  isPrivateChannel: state.channel.isPrivateChannel,
  userPosts: state.channel.userPosts,
  primaryColor: state.colors.primaryColor,
  secondaryColor: state.colors.secondaryColor,
  emotionProbability: state.emotion.emotionProbability
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js